import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';

import {
  Typography,
  Button,
  Divider,
  Checkbox,
  FormControlLabel,
  TextField
} from '@material-ui/core';
import { viewObjects } from 'store/explore/views';

import SizeEditor from 'components/explore/views/objectEditors/SizeEditor';
import ColorEditor from 'components/explore/views/objectEditors/ColorEditor';
import CircleDetail from './CircleDetail';
import LabelDetail from './LabelDetail';
import DistanceMeasuringDetail from './DistanceMeasuringDetail';
import {
  updateExploreObjectById,
  setExploreActiveEditingObject,
  setExploreActiveDrawingObject,
  setManualRadius,
  setExploreFocusedObjectId,
  setIsSideBarOpen,
  appNotify
} from 'store/actions';
import { MapRefContext } from 'components/explore/Explore';
import { isLatLngOnTheScreen, extendBoundsToObject } from 'components/explore/gmap/helpers';
import { getObjectDataProperty } from 'store/explore/views';
import { Constants } from 'utilities/constants';
import { sendClientLog } from 'services/logService';
import { fitBoundsWithZoom } from 'components/explore/gmap/helpers';

const styles = theme => ({
  container: {
    width: 440,
    zIndex: 1,
    position: 'absolute',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#3e4350',
    color: '#fff',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    margin: '8px 0',
  },
  headerText: {
    fontSize: '1.2rem',
    marginRight: 8
  },
  headerRight: {
    //color: '#fff'
    marginRight: 4,
    display: 'flex'
  },
  iconButton: {
    padding: '5px',
  },
  button: {
    marginTop: 8,
    // marginLeft: 24
  },
  editorContainer: {
    padding: '8px 24px 16px'
  },
  editorTitle: {
    marginLeft: -8,
    marginBottom: 4,
    fontSize: '1rem'
  }
});

export function CheckboxDetail(props) {
  const {
    classes,
    isVisible,
    isMeasuringVisible,
    handleChange,
    handleMeasuringChange,
    label,
    measuringLabel,
    title,
    disabled = false,
    disabledMeasuring = false,
  } = props;

  function onChange() {
    handleChange(!isVisible);
  }

  function onMeasuringChange() {
    handleMeasuringChange(!isMeasuringVisible);
  }

  return (
    <>
      <div className={classes.editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={classes.editorTitle}
        >
          {title}
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              onChange={onChange}
              checked={isVisible}
              disabled={disabled}
            />
          }
          label={label}
        />
        {measuringLabel
          ? <div><FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    onChange={onMeasuringChange}
                    checked={isMeasuringVisible}
                    disabled={disabledMeasuring}
                  />
                }
                label={measuringLabel}
          /></div> : null}
      </div>
      <Divider />
    </>
  );
}

const CustomObjectDetail = ({
  classes,
  object,
  handleEditingCancel,
  activeDrawingObject,
  activeEditingObject,
  setExploreActiveEditingObject,
  updateExploreObjectById,
  setExploreActiveDrawingObject,
  mapType,
  radius,
  setManualRadius,
  distanceMeasuringTotalArea,
  distanceMeasuringTotalDistance,
  setExploreFocusedObjectId,
  isMobile,
  setIsSideBarOpen,
  appNotify
}) => {
  const mapRef = useContext(MapRefContext);
  const [showShapePaste, setShowShapePaste] = useState(false);
  const [shapePasteValue, setShapePasteValue] = useState('');

  const handleSizeChange = value => {
    updateExploreObjectById(object.id, { size: value });
  }

  const handleFillOpacityChange = value => {
    updateExploreObjectById(object.id, { fillOpacity: value });
  }

  const handleColorChange = value => {
    let color = value;
    if (isDistanceMeasurement) {
      color = { ...object.color, [mapType]: value }
    }

    updateExploreObjectById(object.id, { color });
  }

  const handleBorderColorChange = value => {
    const borderColor = { ...object.borderColor, [mapType]: value }
    updateExploreObjectById(object.id, { borderColor });
  }

  const handleTitleVisibility = value => {
    updateExploreObjectById(object.id, { isTitleVisible: value });
  }

  const handleMeasuringVisibility = value => {
    updateExploreObjectById(object.id, { isMeasuringVisible: value });
  }

  const handleFontSizeChange = value => {
    updateExploreObjectById(object.id, { size: value, isFontDependsFromZoom: false });
  }

  const handleFontWeightChange = value => {
    updateExploreObjectById(object.id, { fontWeight: value });
  }

  const handleFontColorChange = value => {
    updateExploreObjectById(object.id, { fontColor: value });
  }

  const handleLabelBackgroundColorChange = value => {
    updateExploreObjectById(object.id, { labelBackgroundColor: value });
  }

  const handleIsFontDependsFromZoom = value => {
    updateExploreObjectById(object.id, { isFontDependsFromZoom: value });
  }

  const handleStartDrawing = () => {
    setExploreFocusedObjectId(null);
    setExploreActiveDrawingObject({
      // id: 'tempObject-' + createGUID(),
      id: object.id,
      layerId: object.layerId,
      type: object.type
    });
    if(isMobile) {
      setIsSideBarOpen(false)
    }
  }

  const clearObjectData = () => {
    const objDataProperty = getObjectDataProperty(object.type);
    updateExploreObjectById(object.id, { [objDataProperty]: null });
  }

  const handleDrawingCancel = () => {
    if (object.type === 'Label') {
      clearObjectData();
    }
    setExploreActiveDrawingObject(null);
  }

  const handleDrawingCreate = () => {
    setExploreActiveDrawingObject({ ...activeDrawingObject, isCreating: true });
  }

  const handleDrawingClear = () => {
    clearObjectData();
    if (shapePasteValue) {
      setShapePasteValue('');
    }
  }

  const handleEdit = () => {
    handleBestFitObject();
    setExploreFocusedObjectId(null);
    setExploreActiveEditingObject({ id: object.id, type: object.type, drawingMode: viewObjects[object.type].drawingMode });
    if(isMobile) {
      setIsSideBarOpen(false)
    }
  }

  const handleEditingDone = () => {
    setExploreActiveEditingObject({ id: object.id, type: object.type, drawingMode: viewObjects[object.type].drawingMode, isSaving: true });
  }

  function handleBestFitObject() {
    const objDataProperty = getObjectDataProperty(object.type); // Only returned for custom object types
    if (!objDataProperty || isLatLngOnTheScreen(object[objDataProperty], mapRef?.current)) return;

    const bounds = new window.google.maps.LatLngBounds();
    const expandedBounds = extendBoundsToObject(bounds, object, mapRef);
    if (mapRef?.current) {
      const zoom = mapRef.current.getZoom();
      fitBoundsWithZoom(mapRef.current, expandedBounds);
      if (object.type === Constants.ViewsObjectType.LABEL) { // Don't use new zoom for labels
        mapRef.current.setZoom(zoom); // Set zoom to previous value
      }
    }
  }

  const handleShapePasteStart = () => {
    setShowShapePaste(true);
  }

  const handleShapePasteCancel = () => {
    setShowShapePaste(false);
    if (!isPositionSet) {
      setShapePasteValue('');
    }
  }

  const handleShapePasteSet = () => {
    try {
      const lines = shapePasteValue.split('\n');
      if (lines.length < 3) {
        throw new Error('Value must contain at least 3 lines')
      }

      const parsed = lines.filter(line => line !== '').map(line => {
        const split = line.split(',');
        if (split.length !== 2) {
          throw new Error('Each line must contain two values separated by a comma')
        }
        const parsed = split.map(str => {
          const val = parseFloat(str.trim());
          if (Number.isNaN(val)) {
            throw new Error('Each line must contain two numbers separated by a comma')
          }
          return val;
        })
        return {
          lat: parsed[0],
          lng: parsed[1]
        } 
      })
      const firstPoint = parsed[0];
      const lastPoint = parsed[parsed.length - 1];
      if (firstPoint.lat !== lastPoint.lat || firstPoint.lng !== lastPoint.lng) {
        parsed.push(firstPoint); // close out polygon with initial point
      }
      updateExploreObjectById(object.id, { data: parsed });
      setShowShapePaste(false);
      sendClientLog('Info',`Explore Views - User pasted shape data with ${parsed.length} points for object id ${object.id}, layer id ${object.layerId}`);
    } catch (err) {
      console.log(err)
      const message = err?.message ?? err;
      appNotify(`Pasted value is not valid. ${message}`, 'error');
      sendClientLog('Info',`Explore Views - User encountered error while pasting shape data for object id ${object.id}, layer id ${object.layerId}. Error: ${message}`);
    }
  }

  const handleShapePasteEdit = () => {
    const latestData = object.data
    let dataString = '';
    latestData.forEach((point, index) => {
      dataString += (point.lat + ',' + point.lng);
      if (index !== latestData.length - 1) dataString += '\n';
    })
    setShapePasteValue(dataString);
    setShowShapePaste(true);
  }

  const isEditing = activeEditingObject?.id === object.id;
  const isPositionSet = object.position || object.data;
  const isDistanceMeasurement = object?.type === 'DistanceMeasuring';
  const isShape = object?.type === 'Shape';
  const isLabel = object?.type === 'Label';
  const isCircle = object?.type === 'Circle';
  const isPin = object?.type === 'Pin';
  const isLine = object?.type === 'Line';
  const sizeName = isDistanceMeasurement || isShape || isCircle ? 'Border Width' : 'Size';
  const colorName = isDistanceMeasurement ? 'Shape Color' : 'Color';
  const colorValue = isDistanceMeasurement ? object.color[mapType] : object.color;
  const editBtnName = isDistanceMeasurement ? 'Edit Measuring' : `Adjust ${object.type}`;
  const isDisabledMeasuring = object?.data?.totalData === null;
  const shouldDisableEditors = !isPositionSet || activeDrawingObject != null ||  isEditing;

  const sizeEditorProps = {};
  if (isShape) {
    sizeEditorProps.min = 0;
  }

  return (
    <>
      {isLabel
        ? <LabelDetail
            handleFontSizeChange={handleFontSizeChange}
            handleFontWeightChange={handleFontWeightChange}
            handleFontColorChange={handleFontColorChange}
            handleLabelBackgroundColorChange={handleLabelBackgroundColorChange}
            fontSize={object.size}
            fontWeight={object.fontWeight}
            fontColor={object.fontColor}
            labelBackgroundColor={object.labelBackgroundColor}
            setIsFontDependsFromZoom={handleIsFontDependsFromZoom}
            isFontDependsFromZoom={object.isFontDependsFromZoom}
            shouldDisableEditors={shouldDisableEditors}
          />
        : <>
            <div className={ classes.editorContainer }>
              <Typography variant='subtitle2' color='inherit' className={ classes.editorTitle }>{ sizeName }</Typography>
              <SizeEditor value={ object.size } onChange={ handleSizeChange } { ...sizeEditorProps } disabled={shouldDisableEditors} />
            </div>
            <Divider />
            <div className={ classes.editorContainer }>
              <Typography variant='subtitle2' color='inherit' className={ classes.editorTitle }>{ colorName }</Typography>
              <ColorEditor style={{ marginTop: 6 }} value={ colorValue } onChange={ handleColorChange } disabled={shouldDisableEditors} />
            </div>
            <Divider />
            {(isShape || isCircle) &&
              <>
                <div className={ classes.editorContainer }>
                  <Typography variant='subtitle2' color='inherit' className={ classes.editorTitle }>Fill Opacity</Typography>
                  <SizeEditor style={{ marginTop: 6 }} value={ object.fillOpacity ?? 0.3 } onChange={ handleFillOpacityChange } min={0} max={1} disabled={shouldDisableEditors} />
                </div>
                <Divider />
              </>
            }
          </>
      }
      {
        isShape || isPin || isLine
        ?
        <CheckboxDetail
          classes={classes}
          handleChange={handleTitleVisibility}
          isVisible={object.isTitleVisible}
          label="Show Title"
          title="Title"
          disabled={shouldDisableEditors}
        />
        : null
      }
      {isDistanceMeasurement
        ?
        <>
          <div className={classes.editorContainer}>
            <Typography
              variant='subtitle2'
              color='inherit'
              className={classes.editorTitle}
            >{'Border Color'}
            </Typography>
            <ColorEditor value={object.borderColor[mapType]} onChange={handleBorderColorChange} disabled={shouldDisableEditors} />
          </div>
          <Divider />
          <CheckboxDetail
            classes={classes}
            handleChange={handleTitleVisibility}
            handleMeasuringChange={handleMeasuringVisibility}
            isVisible={object.isTitleVisible}
            isMeasuringVisible={object.isMeasuringVisible}
            label="Show Title"
            measuringLabel="Show Measurements"
            title="Title"
            disabled={shouldDisableEditors}
            disabledMeasuring={shouldDisableEditors || isDisabledMeasuring}
          />
          <Divider />
          <DistanceMeasuringDetail
            totalDistance={distanceMeasuringTotalDistance}
            totalArea={distanceMeasuringTotalArea}
          />
        </>
        : null}
      {isCircle
        ? <>
          <CheckboxDetail
            classes={classes}
            handleChange={handleTitleVisibility}
            handleMeasuringChange={handleMeasuringVisibility}
            isVisible={object.isTitleVisible}
            isMeasuringVisible={object.isMeasuringVisible}
            label="Show Title"
            measuringLabel="Show Measurements"
            title="Title"
            disabled={shouldDisableEditors}
            disabledMeasuring={shouldDisableEditors}
          />
          <Divider />
          <CircleDetail
            radius={radius}
            setManualRadius={setManualRadius}
            disabled={activeDrawingObject === null && activeEditingObject === null}
          />
        </>
        : null
      }

      <div className={classes.editorContainer}>
        <Typography variant='subtitle2' color='inherit' className={classes.editorTitle}>{'Position'}</Typography>
        {activeDrawingObject
          ? <div>
              <Typography>Click on the map to place the object</Typography>
              <div>
                <Button variant='outlined' color='primary' className={classes.button} style={{ marginRight: 8 }} onClick={handleDrawingCancel}>Cancel</Button>
                <Button variant='contained' color='primary' className={classes.button} disabled={!activeDrawingObject.isPlaced} onClick={handleDrawingCreate}>Set</Button>
              </div>
            </div>
          : showShapePaste
            ? <div>
                <Typography style={{ marginBottom: 8 }}>
                  {`Paste values below in `}<i>lat,lng</i>{` pairs separated by new lines.`}
                </Typography>
                <div style={{ display: 'flex', marginBottom: 12 }}>
                  <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <Typography variant='subtitle2'>{'Sample format:'}</Typography>
                    <span>{'42.695099,-101.557617'}</span>
                    <span>{'34.827947,-109.291992'}</span>
                    <span>{'37.593065,-91.054687'}</span>
                  </div>
                  <div/>
                </div>
                <TextField
                  label="Data"
                  autoFocus
                  multiline
                  fullWidth
                  rows={4}
                  rowsMax={20}
                  value={shapePasteValue}
                  onChange={e => setShapePasteValue(e.target.value)}
                  variant='outlined'
                />
                <div>
                  <Button variant='outlined' color='primary' className={classes.button} style={{ marginRight: 8 }} onClick={handleShapePasteCancel}>Cancel</Button>
                  <Button variant='contained' color='primary' className={classes.button} disabled={!shapePasteValue} onClick={handleShapePasteSet}>Set</Button>
                </div>
              </div>
            : isPositionSet
              ? isEditing
                ? <>
                    {!isLabel &&
                      <Button variant='outlined' color='primary' className={classes.button} style={{ marginRight: 8 }} onClick={handleEditingCancel}>Cancel</Button>
                    }
                    <Button variant='contained' color='primary' className={classes.button} onClick={handleEditingDone} disabled={activeEditingObject?.isNotValid}>{`Done`}</Button>
                  </>
                : <div>
                    <Button variant='outlined' color='primary' className={classes.button} style={{ marginRight: 8 }} onClick={handleDrawingClear}>Clear</Button>
                    <Button variant='contained' color='primary' className={classes.button} onClick={handleEdit}>{editBtnName}</Button>
                    {isShape && shapePasteValue &&
                      <Button variant='contained' color='primary' className={classes.button} style={{ marginLeft: 8 }} onClick={handleShapePasteEdit}>Edit Pasted Data</Button>
                    }
                  </div> 
              : <>
                  <Button variant='contained' color='primary' className={classes.button} onClick={handleStartDrawing}>{`Set Position`}</Button>
                  {isShape &&
                    <Button variant='contained' color='primary' className={classes.button} style={{ marginLeft: 8 }} onClick={handleShapePasteStart}>Paste Data</Button>
                  }
                </>
        }
      </div>
      <Divider />
    </>
  )
}

const mapStateToProps = ({ exploreViews, exploreMap, appState }) => {
  return {
    activeDrawingObject: exploreViews.activeDrawingObject,
    activeEditingObject: exploreViews.activeEditingObject,
    mapType: exploreMap.mapType,
    radius: exploreViews.radius,
    distanceMeasuringTotalArea: exploreViews.distanceMeasuringTotalArea,
    distanceMeasuringTotalDistance: exploreViews.distanceMeasuringTotalDistance,
    isMobile: appState.isMobile, 
  }
};

const mapDispatchToProps = {
  updateExploreObjectById,
  setExploreActiveEditingObject,
  setExploreActiveDrawingObject,
  setManualRadius,
  setExploreFocusedObjectId,
  setIsSideBarOpen,
  appNotify
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CustomObjectDetail);
